import { Module } from "wrapper6";
import GA4Tracking from "../public/utils/ga4-tracking";

export default class GA4TrackingHandler extends Module {

  ready () {
    GA4TrackingHandler.addViewItemListOnPageLoad()
  }

  // view_item_list
  static addViewItemListOnPageLoad (selector = null, extraData = null) {
    let ga4Trackings = selector === null ? jQuery('[data-ga4-tracking--vil]') : jQuery(selector)
    if (ga4Trackings.length === 0) {
      return
    }

    ga4Trackings.each((index, ga4Tracking) => {
      let ga4TrackingElement = jQuery(ga4Tracking)
      let ga4TrackingItemsElements = ga4TrackingElement.find('[data-ga4-tracking--item]')
      if (ga4TrackingItemsElements.length === 0) {
        return
      }

      let ga4TrackingData = extraData === null ? null : extraData
      if (ga4TrackingData === null) {
        let g4aTrackingDataAttr = ga4TrackingElement.attr('data-ga4-tracking--data')
        ga4TrackingData = g4aTrackingDataAttr !== undefined
          ? JSON.parse(g4aTrackingDataAttr)
          : null
      }

      let ga4TrackingItems = []
      for (let i = 0; i < ga4TrackingItemsElements.length; i++) {
        let trackingItem = jQuery(ga4TrackingItemsElements[i]).attr('data-ga4-tracking--item')
        ga4TrackingItems.push(JSON.parse(trackingItem))
      }

      GA4TrackingHandler.addViewItemListFromItems(
        ga4TrackingItems,
        ga4TrackingData
      )
    })
  }

  static addViewItemListFromItems (items, extraEcommerceData = null, startIndex = 0) {
    let _items = items
    for (let i = 0; i < _items.length; i++) {
      _items[i].index = i + startIndex
    }

    GA4Tracking.pushEvent(
      'view_item_list',
      _items,
      extraEcommerceData
    )
  }

}